import {
  IconUsers,
  IconCalendarEvent,
  IconSettings,
  IconCash,
} from "@tabler/icons-react";

const features = [
  {
    title: "Member Management",
    description:
      "Handle applications, onboarding, offboarding, and full membership history — all in one place.",
    icon: <IconUsers className="w-6 h-6" />,
  },
  {
    title: "Attendance & Events",
    description:
      "Track attendance at meetings and events, and coordinate planning with your team.",
    icon: <IconCalendarEvent className="w-6 h-6" />,
  },
  {
    title: "Automated Workflows",
    description:
      "Automatically add or remove members from groups and Slack when their status changes.",
    icon: <IconSettings className="w-6 h-6" />,
  },
  {
    title: "Expense Tracking",
    description:
      "Manage your budget with expense tracking broken down by department.",
    icon: <IconCash className="w-6 h-6" />,
  },
];

export function Features() {
  return (
    <section id="features" className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-12">
          Everything your club needs
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white border border-gray-200 rounded-xl p-6"
            >
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-4">
                {feature.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
